import i18n from '../i18n';

const PAYMENT_META = {
    cash: { icon: '💵', atol: 0 },
    card_terminal: { icon: '💳', atol: 1 },
    sbp_qr: { icon: '📱', atol: 1 },
    online_card: { icon: '🌐', atol: 1 },
    online_sbp: { icon: '🌐', atol: 1 },
    balance: { icon: '💰', atol: 1 },
    bonus: { icon: '⭐', atol: 1 },
    online: { icon: '🌐', atol: 1 },
    advance: { icon: '📋', atol: 1 }
};

export function paymentLabel(code) {
    const meta = PAYMENT_META[code];
    if (!meta) return { label: code, icon: '💳', atol: 1 };
    return {
        label: i18n.t(`payments:methods.${code}`),
        icon: meta.icon,
        atol: meta.atol
    };
}

export function getPaymentLabels() {
    return Object.fromEntries(
        Object.keys(PAYMENT_META).map((code) => [code, paymentLabel(code)])
    );
}

export const PAYMENT_LABELS = new Proxy(
    {},
    {
        get(_target, code) {
            if (typeof code !== 'string') return undefined;
            return paymentLabel(code);
        }
    }
);

export function paymentDisplay(code) {
    const p = paymentLabel(code);
    return `${p.icon} ${p.label}`;
}
